export const DISHESDICT = ['Basic', 'Regular', 'Luxury', 'Supreme']


// 各类型常量不要一样！！！
// nftMaster合约
export const NFTTYPE = Object.freeze({
  COMBO: 'COMBO',
  COMBO_V2: 'COMBO_V2',
  COMBO_V3: 'COMBO_V3',
  SOCCER: 'SOCCER',
  SOCCER_V2: 'SOCCER_V2',
  SOCCER_V3: 'SOCCER_V3',
  POKER: 'POKER',
  POKER_V2: 'POKER_V2',
  POKER_V3: 'POKER_V3',
  GAMEBOX: 'GAMEBOX',
  CAR: 'CAR',
  CAR_V2: 'CAR_V2',
  CAR_V3: 'CAR_V3',
  GIFTBOX: 'GIFTBOX',
  DOGGIES: 'DOGGIES',
  DOGGIES_V2: 'DOGGIES_V2',
  DOGGIES_V3: 'DOGGIES_V3',
  BARKING: 'BARKING',
  BARKING_V2: 'BARKING_V2',
  BARKING_V3: 'BARKING_V3',
  YOOSHI: 'YOOSHI',
  EQUIPMENT: 'EQUIPMENT',
  EQUIPMENT_V2: 'EQUIPMENT_V2',
  EQUIPMENT_V3: 'EQUIPMENT_V3',
  MATRIX: 'MATRIX',
  BAKEMUSKMIXER: 'BAKEMUSKMIXER',
  BAKEMUSKMIXER_V2: 'BAKEMUSKMIXER_V2',
  BAKEMUSKMIXER_V3: 'BAKEMUSKMIXER_V3',
  MUSKUSMLAND: 'MUSKUSMLAND',
  GAMEACE: 'GAMEACE'
})

// 各类型常量不要一样！！！
// bidNft合约
// NFT Marketplace type
export const MARKETTYPE = Object.freeze({
  BAKERYARTWORK: 'BAKERYARTWORK',
  MUSKDOGE: 'MUSKDOGE',
  MEME: 'MEME',
  ONEINCH: 'ONEINCH',
  SEASCAPE: 'SEASCAPE',
  BAKERYSOCCER: 'BAKERYSOCCER',
  TKONFT: 'TKONFT',
  BTCARTWORK: 'BTCARTWORK',
  SFPARTWORK: 'SFPARTWORK',
  POKERCARD: 'POKERCARD',
  CARNFT: 'CARNFT',
  DOGGYNFT: 'DOGGYNFT',
  LOVE: 'LOVE',
  BARKNFT: 'BARKNFT',
  YOOSHINFT: 'YOOSHINFT',
  ARTWORK: 'ARTWORK',
  DISH: 'DISH',
  EGGNFT: 'EGGNFT',
  WEAPONNFT: 'WEAPONNFT',
  BINANCENFT: 'BINANCENFT',
  PETNFT: 'PETNFT',
  GAMEBOXNFT: 'GAMEBOXNFT',
  RACANFT: 'RACANFT',
  BONDLYNFT: 'BONDLYNFT',
  BAKERYBSCARTWORK: 'BAKERYBSCARTWORK'
})

export const MARKETTYPEV1 = Object.freeze({
  BAKERYARTWORKV1: 'BAKERYARTWORKV1',
  MUSKDOGEV1: 'MUSKDOGEV1',
  MEMEV1: 'MEMEV1',
  ONEINCHV1: 'ONEINCHV1',
  SEASCAPEV1: 'SEASCAPEV1',
  BAKERYSOCCERV1: 'BAKERYSOCCERV1',
  BTCARTWORKV1: 'BTCARTWORKV1',
  SFPARTWORKV1: 'SFPARTWORKV1',
  ARTWORKV1: 'ARTWORKV1',
  DISHV1: 'DISHV1',
  EGGNFTV1: 'EGGNFTV1',
  WEAPONNFTV1: 'WEAPONNFTV1',
  BINANCENFTV1: 'BINANCENFTV1',
  PETNFTV1: 'PETNFTV1',
  BARKNFTV1: 'BARKNFTV1',
  BONDLYNFTV1: 'BONDLYNFTV1',
  RACANFTV1: 'RACANFTV1',
  YOOSHINFTV1: 'YOOSHINFTV1',
  LOVEV1: 'LOVEV1',
  DOGGYNFTV1: 'DOGGYNFTV1',
  TKONFTV1: 'TKONFTV1',
  BAKERYBSCARTWORKV1: 'BAKERYBSCARTWORKV1',
})

export const MARKETTYPEV3 = Object.freeze({
  BAKERYARTWORKV3: 'BAKERYARTWORKV3',
  MUSKDOGEV3: 'MUSKDOGEV3',
  MEMEV3: 'MEMEV3',
  ONEINCHV3: 'ONEINCHV3',
  SEASCAPEV3: 'SEASCAPEV3',
  BAKERYSOCCERV3: 'BAKERYSOCCERV3',
  TKONFTV3: 'TKONFTV3',
  BTCARTWORKV3: 'BTCARTWORKV3',
  SFPARTWORKV3: 'SFPARTWORKV3',
  POKERCARDV3: 'POKERCARDV3',
  ARTWORKV3: 'ARTWORKV3',
  DISHV3: 'DISHV3',
  CARNFTV3: 'CARNFTV3',
  EGGNFTV3: 'EGGNFTV3',
  WEAPONNFTV3: 'WEAPONNFTV3',
  BINANCENFTV3: 'BINANCENFTV3',
  PETNFTV3: 'PETNFTV3',
  BARKNFTV3: 'BARKNFTV3',
  BONDLYNFTV3: 'BONDLYNFTV3',
  RACANFTV3: 'RACANFTV3',
  YOOSHINFTV3: 'YOOSHINFTV3',
  LOVEV3: 'LOVEV3',
  DOGGYNFTV3: 'DOGGYNFTV3',
  BAKERYBSCARTWORKV3: 'BAKERYBSCARTWORKV3',
  TOKAUV3: 'TOKAUV3',
  EQUIPMENTV3: 'EQUIPMENTV3',
  MATRIXV3: 'MATRIXV3',
  TOYV3: 'TOYV3',
  KAKAV3: 'KAKAV3',
  KTAV3: 'KTAV3',
  KRBV3: 'KRBV3',
  BAKEMUSKV3: 'BAKEMUSKV3',
  GAMEBOXNFTV3: 'GAMEBOXNFTV3',
  EQUIPMENTMULTITOKENV3: 'EQUIPMENTMULTITOKENV3',
  MUSKUSMLANDNFTV3: 'MUSKUSMLANDNFTV3',
  BLINV3: 'BLINV3',
  BINAMONV3: 'BINAMONV3',
  GAV3: 'GAV3',
  KRIPTOMONV3: 'KRIPTOMONV3'
})

// 各类型常量不要一样！！！
// exchaneNfts合约
export const MARKETMULTITOKEN = Object.freeze({
  RACAMULTITOKEN: 'RACAMULTITOKEN',
  TOKAUMULTITOKEN: 'TOKAUMULTITOKEN',
  POKERMULTITOKEN: 'POKERMULTITOKEN',
  EQUIPMENTMULTITOKEN: 'EQUIPMENTMULTITOKEN',
  MATRIXMULTITOKEN: 'MATRIXMULTITOKEN',
  TOYMULTITOKEN: 'TOYMULTITOKEN',
  KAKAMULTITOKEN: 'KAKAMULTITOKEN',
  BAKEMUSKMIXERMULTITOKEN: 'BAKEMUSKMIXERMULTITOKEN'
})

// 各类型常量不要一样！！！
// NFT support token
export const SUPPORTTYPE = Object.freeze({
  POKER: 'POKER',
  SOCCER: 'SOCCER',
  BAKE: 'BAKE',
  PET: 'PET',
  SFP: 'SFP',
  CAR: 'CAR',
  BNB: 'BNB',
  DOGGY: 'DOGGY',
  BARK: 'BARK',
  RACA: 'RACA',
  DOGE: 'DOGE',
  TOKAU: 'TOKAU',
  BUSD: 'BUSD'
})
